module.exports = __webpack_public_path__ + "static/google_playstore-e17d7834c0617da4df64b686c149b8fe.png";